import React from "react";
import {ComingSoon} from "../../components/ComingSoon/ComingSoon";

export default function MaintenanceInformationView() {
    return (
        <div className="flex flex-col items-center justify-center py-16">
            <ComingSoon />
        </div>
    );
}
